import { Box, styled } from "@mui/material";

export const Root = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    height: "-webkit-fill-available",
}));

export interface AvailabilityStatusProps {
    color: string;
}

export const Dot = styled("span")<AvailabilityStatusProps>(({ theme, color }) => ({
    width: "6px",
    height: "6px",
    borderRadius: "3px",
    ...(color === "green" && {
        backgroundColor: theme.palette.green._50,
    }),
    ...(color === "yellow" && {
        backgroundColor: theme.palette.yellow._50,
    }),
    ...(color === "red" && {
        backgroundColor: theme.palette.red._50,
    }),
    ...(color === "grey" && {
        backgroundColor: theme.palette.core.grey._30,
    }),
}));
